import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
//import { AuthService } from "./services/auth.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  currentUser: any;
  constructor() {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.currentUser = JSON.parse(sessionStorage.getItem('currentJwtToken'));
    if (this.currentUser && this.currentUser.id_token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.currentUser.id_token}`,
          'Cache-Control':
            'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
          Pragma: 'no-cache',
          Expires: '0',
        },
      });
    }

    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // handle successful response if needed
        }
      }),
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            // this.authService.logout();
            // this.authService.redirectLogoutUser();
          }
        }
        return throwError(() => err);
      })
    );
  }
}
